import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import {Button, Col, Container, InputGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap"

import {useDispatch, useSelector} from "react-redux";

import {getServices as onGetServices} from "../../store/actions";

const OnCallModal = props => {

  const dispatch = useDispatch()

  const {oncalls} = useSelector(state => ({
    oncalls: state.Oncalls.oncalls
  }));

  useEffect(() => {
    dispatch(onGetServices());
  }, [onGetServices]);

  const [allOncalls, setAllOncalls] = useState([
    {service_id: props.serviceId, oncall_type: "", oncall_engineer_email: "", config_value: "Email"},
  ]);

  const handleFormChange = (index, event) => {
    let data = [...allOncalls];
    data[index][event.target.name] = event.target.value;
    setAllOncalls(data);
  }

  const addFields = () => {
    let newfield = {service_id: props.serviceId, oncall_type: "", oncall_engineer_email: "", config_value: "Email"}
    setAllOncalls([...allOncalls, newfield])
  }

  const removeFields = (index) => {
    let data = [...allOncalls];
    data.splice(index, 1)
    setAllOncalls(data)
  }

  const submit = (e) => {
    e.preventDefault();
    dispatch(postServiceOnboarding({'services': allOncalls}));
  }

  const oncallTypes = ['Primary', 'Secondary', 'Tertiary']


  const {isOpen, toggle} = props
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>On Call Details</ModalHeader>
        <ModalBody>
          <Container>
            {
              allOncalls.map((input, index) => {
                return (
                  <Row className="justify-content-center gy-2 gx-3 mt-3" key={index}>
                    <Col md={4}>
                      <select
                        id="formrow-InputState"
                        name="oncall_type"
                        className="form-control"
                        value={input.oncall_type}
                        onChange={event => handleFormChange(index, event)}
                      > {
                        input.oncall_type === '' ? (
                          <option>Select on-call type</option>
                        ) : null

                      }
                        {oncallTypes.map((item, key) => (<option key={key} value={item}>{item}</option>)
                        )}
                      </select>
                    </Col>
                    <Col md={4}>
                      <Label className="visually-hidden" htmlFor="autoSizingInputGroup">Name</Label>
                      <InputGroup>
                        <input
                          type="text"
                          name="email"
                          value={input.email}
                          className="form-control"
                          id="autoSizingInputGroup"
                          placeholder="Name"
                          onChange={event => handleFormChange(index, event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={4}>
                      <Button
                        color="danger"
                        className="btn btn-danger waves-effect waves-light"
                        onClick={() => removeFields(index)}
                      >
                        Remove
                      </Button>
                    </Col>

                  </Row>
                )
              })
            }
          </Container>
        </ModalBody>
        <ModalFooter>
          <div className="col-sm-auto">
            <button
              className="btn btn-primary btn-block"
              onClick={addFields}
            >
              Add More
            </button>
          </div>
          <div className="col-sm-auto">
            <button
              className="btn btn-success btn-block"
              onClick={submit}
            >
              Save
            </button>
          </div>
        </ModalFooter>
      </div>
    </Modal>
  )
}

OnCallModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  serviceId: PropTypes.any,
}

export default OnCallModal
